import createRoleSrc from '../assets/illustrations/undraw/create-role.svg';
import createSrc from '../assets/illustrations/undraw/create.svg';
import importSrc from '../assets/illustrations/undraw/import.svg';
import teamSrc from '../assets/illustrations/undraw/team.svg';
import brandSrc from '../assets/illustrations/undraw/brand.svg';
import structureSrc from '../assets/illustrations/undraw/structure.svg';
import detailsSrc from '../assets/illustrations/undraw/details.svg';
import optionsSrc from '../assets/illustrations/undraw/options.svg';
import locationSrc from '../assets/illustrations/undraw/location.svg';
import styles from './SetupWizard.module.css';

/** Vendored unDraw art for setup path empty states (NOTICE.md in assets). */
export type SetupWizardPathArtKind =
  | 'create-role'
  | 'create'
  | 'import'
  | 'team'
  | 'brand'
  | 'structure'
  | 'details'
  | 'options'
  | 'location';

const SRC: Record<SetupWizardPathArtKind, string> = {
  'create-role': createRoleSrc,
  create: createSrc,
  import: importSrc,
  team: teamSrc,
  brand: brandSrc,
  structure: structureSrc,
  details: detailsSrc,
  options: optionsSrc,
  location: locationSrc,
};

export function SetupWizardPathArt({
  kind,
  className,
}: {
  kind: SetupWizardPathArtKind;
  className?: string;
}) {
  return (
    <img
      src={SRC[kind]}
      alt=""
      aria-hidden
      draggable={false}
      className={[styles.pathArt, className].filter(Boolean).join(' ')}
    />
  );
}
